export const MODAL_NAMES = {
  KONBINI_SETTINGS: 'options.payment.konbini.settings',
}
